
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5 10h9V8H5v2zm0 4h9v-2H5v2zM16 4v13c0 .551-.449 1-1 1H4c-.551 0-1-.449-1-1V4c0-.551.449-1 1-1h1.5v3h8V3H15c.551 0 1 .449 1 1zM7.5 4h4V2h-4v2z"}})])
          )
        }
      }
    